import { render, staticRenderFns } from "./DashboardSubscriptionsBaseSales.vue?vue&type=template&id=123d169e&scoped=true"
import script from "./DashboardSubscriptionsBaseSales.vue?vue&type=script&lang=js"
export * from "./DashboardSubscriptionsBaseSales.vue?vue&type=script&lang=js"
import style0 from "./DashboardSubscriptionsBaseSales.vue?vue&type=style&index=0&id=123d169e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123d169e",
  null
  
)

export default component.exports